import {ssrLazy} from 'ssr/lazy';

export const SuperheroSSRLazy = ssrLazy(() => import(/* webpackChunkName: "superheroSSR" */ '.'));
